Util = require 'app/scripts/lib/util'
PopOver = require 'app/scripts/views/lib/pop-over'

CopyBoardView = require 'app/scripts/views/board/copy-board-view'

module.exports.copyBoard = (e) ->
  Util.stop(e)
  PopOver.toggle
    elem: @$(e.target).closest('.js-copy-board')
    view: new CopyBoardView({ @model, @modelCache })
